import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const DataIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 32 21"
    >
      <g transform="translate(1 1)">
        <ellipse
          cx="8.056"
          cy="2.967"
          rx="8.056"
          ry="2.967"
          transform="translate(6.944)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M534.023,203.322c0,1.639-3.606,2.967-8.055,2.967s-8.057-1.328-8.057-2.967"
          transform="translate(-510.968 -196)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M534.023,207.678c0,1.639-3.606,2.967-8.055,2.967s-8.057-1.328-8.057-2.967"
          transform="translate(-510.968 -196)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M534.023,212.033c0,1.639-3.606,2.967-8.055,2.967s-8.057-1.328-8.057-2.967"
          transform="translate(-510.968 -196)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="13.066"
          transform="translate(6.944 2.967)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="13.066"
          transform="translate(23.056 2.967)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="0.89"
          y2="0.68"
          transform="translate(1.661 2.923)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="0.89"
          y1="0.68"
          transform="translate(27.449 15.397)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="1.37"
          transform="translate(0 9.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="1.37"
          transform="translate(28.63 9.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y1="0.68"
          x2="0.89"
          transform="translate(2.084 16.125)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="0.89"
          y2="0.68"
          transform="translate(27.026 2.195)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
